<template>
    <div class="price-display">
        <img src="@/assets/pricedisplay.png" alt="price" />
    </div>
</template>

<style scoped>
.price-display {
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 10px;
    max-width: 1200px;
    margin: 20px auto;
    padding: 5px;
}
.price-display img {
    max-width: 100%;
    height: auto;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}
</style>